let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Miiv")).then(() => parcelRequire('lwbhR'));